import { Component, Input, OnInit, Output } from '@angular/core';
import { CategoryType } from '@enum/category-type';
import { Category } from '@model/category/category';
import { CategoriesService } from '@service/categories.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'region-picker-dropdown',
  templateUrl: './region-picker-dropdown.component.html',
  styleUrls: ['./region-picker-dropdown.component.scss']
})
export class RegionPickerDropdownComponent implements OnInit {

  @Input()
  public set selectedId(id: number) {
    this._selectedId = id

    if (this.isChildrenOfIndex)
      this.setSelectModelFromInputId(id)
  }
  public get selectedId() {
    return this._selectedId
  }
  private _selectedId: number = null

  public resetCategory: Category = new Category({ name: "Alle", id: -1 })
  public selectedCountry: Category = this.resetCategory
  public selectedRegion: Category = this.resetCategory

  @Output()
  public onCategorySelect: Subject<any> = new Subject()

  public categories: Category[] = null

  // {id -> country/region}
  private byIdIndex = null
  // {region.id -> country}
  private isChildrenOfIndex = null

  constructor(
    private categoriesService: CategoriesService,
  ) { }

  ngOnInit() {
    this.categoriesService.getCategories(CategoryType.job)
      .then((categories: Category[]) => {
        this.categories = categories

        // LOOP FUSION
        // - build by id index for faster access later
        // - build "is children of index" for faster access later
        this.byIdIndex = {}
        this.isChildrenOfIndex = {}
        for (let c of categories) {
          this.byIdIndex[c.id] = c
          for (let r of c.children) {
            this.byIdIndex[r.id] = r
            this.isChildrenOfIndex[r.id] = c
          }
        }

        if (this.selectedId)
          this.setSelectModelFromInputId(this.selectedId)
      })
  }

  private setSelectModelFromInputId(id: number) {
    // if the selected id is not a children of another -> its a country
    if (typeof this.isChildrenOfIndex[id] == "undefined") {
      this.selectedCountry = this.byIdIndex[id]
    }
    // else its a region
    else {
      this.selectedCountry = this.isChildrenOfIndex[id]
      this.selectedRegion = this.byIdIndex[id]
    }
  }

  public selectCountry(event) {
    let c: Category = event.value

    // selected "alle" (reset filter)
    if (c.id == -1) {
      this.resetFilter()
    }
    // selected a new country
    else {
      this.selectedRegion = this.resetCategory
      this.selectedId = c.id
      this.onCategorySelect.next({ filter: 'job_category_id', value: c.id })
    }
  }

  public selectRegion(event) {
    let r: Category = event.value

    // selected "alle" (reset filter)
    if (r.id == -1) {
      this.selectedRegion = this.resetCategory

      if (this.selectedCountry)
        this.onCategorySelect.next({ filter: 'job_category_id', value: this.selectedCountry.id })
      else
        this.onCategorySelect.next({ filter: 'job_category_id', value: null })
    }
    // selected a new region
    else {
      this.selectedId = r.id
      this.onCategorySelect.next({ filter: 'job_category_id', value: r.id })
    }
  }

  public resetFilter() {
    this.onCategorySelect.next({ filter: { isFilterReset: true } })
  }
}
